module.exports = "/_next/static/images/NJLogo-1d6c86c1387d12a475ae2155cb03c005.png";